<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="epigraph"><span><i>See, I have this special responsibility to my kids. Because to them I’m not just some actor playing Uncle Chubby. I AM Uncle Chubby. And that means a lot to me. Heck, that means everything.</i></span></p>
<p class="center"><span>—from an interview with Lyle Hudnut in <i>TV Guide</i>, two weeks before his arrest</span></p>
<p class="center"><span><i>Nobody ever drowned in shallow.</i></span></p>
<p class="center"><span>—old sitcom writers’ saying</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5epigraph.vue?560b62fe